export default "__VITE_ASSET__8580e208__"